const LugosiAllReleasesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6guHBxRr1BVszzT7TwlC6N?si=68c91bb7ec1344cd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-GyyxDhzpIwTOfwwP-zw68rg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>girlinmyphone 2 (feat. riley west)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6guHBxRr1BVszzT7TwlC6N?si=68c91bb7ec1344cd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-CZ7BMRl0nFSQ6CKZ-XgtLzQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>bile&toxins</strong><br/>
                (prod. secre)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0PLxCWe3Xygp5Akq8F3muI?si=d29500663a92478e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-FGDPQiqHhxz5diwM-vZ7gqA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>bile&toxins $$$</strong><br/>
                (prod. secre)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3dR5dR9c1Ufr1f3vXMSMpi?si=991af5f56b1549bc" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-o16oWS7gN8uuQzO8-EVXIFA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>bile&toxins ^^^</strong><br/>
                (prod. secre)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/surface-ft-32drew" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-6y2EDYOtc56d5s8v-srwKdA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>surface (feat. 32drew)</strong><br/>
                (prod. mackk)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2SAIRjrYTHhhTQ1T7kZzzl?si=7553eae69dd74bae" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>happy again</strong><br/>
                (prod. jolst & pekarot)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0bDsSVgrezOWEiag2x69K3?si=f3ba7038eb2449a5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>clean</strong><br/>
                (prod. frevel)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6CPcFYnDv8qOFLmYIRi3HW?si=66a587756ac8430e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>hunter</strong><br/>
                (prod. yunny goldz)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0RB9xQ11eEh4fo6m8o5Apx?si=63a9c593fde24d3d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>holdmedown interlude v3</strong><br/>
                (prod. 1080PALE)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2cjYSlnI31vHZiSw5rGIoY?si=42f34f8afb5a4e9e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>mean it</strong><br/>
                (prod. irby & jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4mgxXe2LCeclJxYodLzsN8?si=83580a4ab35e46a5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>girlinmyphone</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/07moCJwHJAlE2XFA096hIG?si=db13ae9aa8134039" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>girlinmyphone [NIGHTCORE]</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3VgT0XFHN8QrqiKl66LTqp?si=5a2bff7b43034a49" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Eyq0reGx3y8HFZz4-zEkbzQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>girlinmyphone [slow+reverb]</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1L0PRWcS6Nn2Mza6LWekWR?si=3adabe495c364349" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-XYk9DaEBl32Lr8YR-otcFtg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>upmyprice</strong><br/>
                (prod. notamahcine & starsmp3)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2sgPNpt2PFlW0Y4IiVUUFx?si=91b64ea224ad442b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-4UPtWoc3Jkfm15ye-hQ4BTA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>upmyprice [NIGHTCORE]</strong><br/>
                (prod. notamahcine & starsmp3)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3YWCRZD1ntDiqpFoyyuvio?si=364c1d95418f4c58" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-ydtgdccTloWaC9Jw-BkNswg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>6FEET</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0oeIMpaGMP099cUdlV1khI?si=0ccda74e26d44461" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-h4sgaQPvcqu9SuTA-dH2F9Q-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>worse</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/fraen-fine-9-nightcore" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-5NjdIRYfOi6xymlj-yoF1Hg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>frän fine (9) [NIGHTCORE]</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5Np0DUQ5W5yqJZV5Nv6Vou?si=7f14d8ce1c254e88" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-5Gl10Ad2jVs0l5tc-FRTryg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>BLOW</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0ilRYMgC9b7uJIcPm1Qe9e?si=cbf7d1635ab34d3d" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AT7H3p1VmaGSvcQR-mCMfuQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>higher</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7mkkxIPsWGEyS6bSuUSZj6?si=9424d6e28fbd4194" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>rental</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2CTeUBxNia6iCHTE2y8GLe?si=2b8dd43af2d4401f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>snow</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4kQK8U1Bwx3CsYZs6JV9Aw?si=0ecbc09185444512" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>pressure (steez)</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6Efy8gn5J0OCxp6V7Y0KvS?si=e832cac7ec024353" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>save that</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3GEK0coBAfQvnrN81WMt9e?si=c4969ae44bb84e87" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>firefly</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/47o2alVtRw5IPsi2NnXWOB?si=16a89a757ebe46aa" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-CH8bh09tMK3mGAPw-Seh47A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>allurpain</strong><br/>
                (prod. cl6udy x jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/bad-bitch-prod-wintfye-open-4-baby-osama" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-CGueGSJkjsyAdBFP-xIEUrA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>bad bitch (feat. baby osama)</strong><br/>
                (prod. Wintfye)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Music Video / Single</p>
            <a href="https://www.youtube.com/watch?v=2-770OlCAYc" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-yy68X89uin4lRYwY-3kzbEw-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>rice</strong><br/>
                (prod. bygadriel)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/19gjH663KG6k84FsjMPLok?si=a75a5b7fd9a94f3f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>big (die tonight)</strong><br/>
                (prod. shinju & taylor morgan)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5UGbQ8Vv6n3t5dU6oh5nx8?si=6ba13f8e4a574a75" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>$creamin%%%</strong><br/>
                (prod. Ugly Beats)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0YHNqTEXdkHFzPKxFYFOn9?si=73f280f6e6424081" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>$tre$$ (feat. Lil Dujour)</strong><br/>
                (prod. Ugly Beats)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5mSeARHVVZiFy9U2RKtDoT?si=360d593579dc49e3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>on g0d (feat. Boy Floss)</strong><br/>
                (prod. itsmefouzy)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/18bJWL6krjiyNR4C9wwu0o?si=8121e46f0ca0443c" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>u$ v3</strong><br/>
                (prod. Jolst)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4nBFeSoSkHFBUVKln62JE6?si=ed2c426c1d994358" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>kino der toten (feat. Newalias)</strong><br/>
                (prod. kagayaki)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5SlHqGNRyPlCReXG2QBFmc?si=85e6372989694720" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>nerd$ rope</strong><br/>
                (prod. Jolst)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4xIv2QMw15eMj2urIIsBSg?si=0953932754e84b6f" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>frän fine (9)</strong><br/>
                (prod. itsmefouzy)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3OStwiruzHj2kVIz0ljK0z?si=78c2578115054de4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>WHATSINYOCUP</strong><br/>
                (prod. OhMyGon!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2aZQtMMpNlpOHGNoBcTSbY?si=91f4610b6306486b" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>hone$tly</strong><br/>
                (prod. Meauxminy)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2sTpAhjPgRVpUPZmboygbp?si=e0fb32b8b49040e8" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>bulletproof</strong><br/>
                (prod. Jolst)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/62QksB8fuA5h5SriHVm3sh?si=23994054e9fc4b48" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>g00fy bitch free$tyle</strong><br/>
                (prod. Kawaii Ry)
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/2y7Ob9mEbDcSN2zlr8gx4c?si=ec2010d33dac44a5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02794a65ba4b225e2f483fd3a1" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>zx sallow & Nate Hollow - Sacrifice (feat. Lugosi)</strong><br/>
                (prod. Gmanz)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6d9A2SPqK59qCzjty5rD4m?si=560b65ca4a4f46e5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>kill 4 you</strong><br/>
                (prod. jolst & 5head)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1E5C2fjIBnz3FEZIDcCNeS?si=7a4396f88b954ae5" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>throughtherain</strong><br/>
                (prod. ugly beats)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2PbTn8Cn0v55tBm3Qosumo?si=b7d57598cc5f4c74" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>tragic</strong><br/>
                (prod. jolst & 5head)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/38YrKFKFLRU923EP5Dl96O?si=46a17cda8b8b4d12" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>burn holes</strong><br/>
                (prod. notamachine & rjpasin)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2FiKoq8EzKkYuGwGzM7Anr?si=b15a5820130644d3" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>goinoutsad</strong><br/>
                (prod. jolst & thislandis)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6AzXRbvSqff6Y15fp9W6Xw?si=c9eee4a87531425e" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>paranoid</strong><br/>
                (prod. jolst, ertu & wasterr)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cqwO1a9HesEJJ4MpG92U6?si=b668f624f2f04bb4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>truey on truey</strong><br/>
                (prod. trunks & thislandis)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/74XbWghfe7umH8kIsdQJVY?si=54eeb783a9b747b4" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>goinoutsadv2</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3V50ZTDDET86sQo9gKwFfF?si=cf0bd3d342094f3c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>notamachine - enjoy yourself</strong><br/>
                (feat. Kawaii Ry & Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/6f0wOhCOhyz8S7pR5HiZGj?si=b6f34406a5b741d2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>notamachine - faded</strong><br/>
                (feat. Lugosi)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6AKfhwQkwgQ4hWBDZNWAZ8?si=f5c232a6041749bc" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PHOTO</strong><br/>
                (prod. chris6lair & Rio Leyva)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0I5rJlaBkO20fULmnRwQLt?si=729abdeee4ac4e08" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>RUNTZ</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2HilJDWDjosfDgUGeZRYZd?si=c5aa2bc772a14fe7" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>2ICY</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2w07H6GivKVa0smoNfePdP?si=71389f79d0fa4256" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>GEEKIN</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/51IKc0tBc5VQebIgKpt1ee?si=5856e134990347ac" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BIG BOYS</strong><br/>
                (prod. chris6lair & TF)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4cW0oMR1t5I53h417vwa2T?si=0e18b91cd74d4a66" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PISTOLTUCKED</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/32HZhtJOV3cj8iObJdadYj?si=e7031c7bdb5944af" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Hey Lugosi</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5Y3RT0cNWDm32BCFpEbCOu?si=dfd67e4cdf9f41f1" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - 40 (feat. rileylol)</strong><br/>
                (prod. gotti)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1h1bV5x6Rqak2ZYNbc6JzC?si=0b1c59bbfcd64ba8" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - FYBB</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/6s1JmW3MXAb2BH9jFi8w13?si=604dfba0a31f48e2" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Remy Truck</strong><br/>
                (prod. Remy3D & notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1cBIAPbkt6Mb4qrbTzrvuq?si=cd741088348c4148" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Schoolin' (feat. Remy3D)</strong><br/>
                (prod. Meauxminy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0NzImhZKMO4N0YWy2gU0XA?si=be8a36a1e55f4ed5" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Oh So Fine</strong><br/>
                (prod. bleachh)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5MuS0w5MtGeXNSqo1WFVay?si=14d98e6e598047e8" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Feelin' Old</strong><br/>
                (prod. chris6lair & toobears)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/221eCCU3D8CGq0HgxZXjSG?si=859fd72f996f4715" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Q2HxnkWZU8VXJnaB-wAoMKw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BREAKING UP</strong><br/>
                (prod. notamachine & Gotti)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/gone-for-a-minute-prod?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>gone for a minute</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/howlong-prod-taurs?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>HOWLONG</strong><br/>
                (prod. Taurs)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/mover-shaker-prod-cl6udy?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>mover//shaker</strong><br/>
                (prod. Cl6udy & sovdes)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/saveme-prod-klimlords?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SAVEME</strong><br/>
                (prod. Klimlords)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/slow-mo-prod-cl6udy?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>slow mo</strong><br/>
                (prod. Cl6udy & Jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/onechance-prod-taurs?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>onechance</strong><br/>
                (prod. Taurs)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/grip-prod-taurs-x-jolst?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>grip</strong><br/>
                (prod. Taurs & Jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/bin2-prod-jvsper?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>bin2</strong><br/>
                (prod. Jvsper)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/wrentonmywrist-prod-wissery-x?in=lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>wrentonmywrist</strong><br/>
                (prod. Wissery & Jolst)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/223-freestyle-prod-hxllxw" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-V1jgun19144MELyM-hHHWhg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>.223 FREESTYLE</strong><br/>
                (prod. HXLLXW)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1AYPa7Fn3NhxQXzU6Z5jsA?si=ee7672cbf6454f2c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27382c44367bee2d4fcf3ec9ae8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ghostsinthewalls</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4nIshbZYcRbO4tfW96RdCk?si=5e8ba565f1634e47" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27382c44367bee2d4fcf3ec9ae8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>inthemud</strong><br/>
                (prod. Collo)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0AlO3h0cnKHLcCGKojDGj6?si=a38480a6d6314dec" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27382c44367bee2d4fcf3ec9ae8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>topme (glockie)</strong><br/>
                (prod. Taurs, Thislandis)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/5KD8KacsVrnRgrIsmNhQTt?si=9528e5ffa2304123" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - lugosi in a ghost (feat. Lugosi)</strong><br/>
                (prod. Fedia)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/lugosi-lovelyinthemoonlight-prod-pekarot" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-TBtZNn6HgAfciJRk-LVClZg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>lovely</strong><br/>
                (prod. Pekarot)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1I44gwUuJyRXxuP1vp6JFQ?si=ec6174192bd341f9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273194a8d46291067ad062d1077" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Loudpak Shawty - Don't Matter (feat. Lugosi)</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>   

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://soundcloud.com/kawaiiry/no-smoke-ab-minor?in=kawaiiry/sets/kawaiis-archives-vol-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-GlX4ANTrmFCQA1I5-AusZ1Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - NO SMOKE (feat. Lugosi)</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/disposable-prod-semaj" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-JiSnVvbUUrB7ZMh5-zYJFhA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>disposable</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/23AUR4GQFxUQChbY8nFAda?si=93a7a2ffc4674398" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27381284948b222fde968511143" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>everypartofme (feat. Svnam)</strong><br/>
                (prod. Pekarot, Metlast)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7hr0BloDzgMeoCFQz0O5yD?si=7abfe421dd2343cc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273c0901cf3688f3a586aefa0d6" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>RUN IT UP</strong><br/>
                (prod. assa, dexn)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7DqKnfsHGSqEOTF4pK36eN?si=64314b833d4c4de8" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2739572d52c3c656068dce4366c" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>THANOS (feat. Kawaii Ry)</strong><br/>
                (prod. Sorrow Bringer)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/deathbed-pekarot" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-qgzzOkYTsKAWL4Jm-Z2MonA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>deathbed</strong><br/>
                (prod. Pekarot)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/74CXyhJ7tgYeBjOmAeqHlU?si=ababf8409515428f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273f1fd8c4151c812d8145c5ed5" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>alone (feat. Barren)</strong><br/>
                (prod. Irby, Splashgang)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5L3NihhB1hRVChyuznMJlf?si=fbad18b3278a4bc2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2737295d25e0f93408721815655" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>safe</strong><br/>
                (prod. Sorrow Bringer)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3a1oG6qzc6SjMkQGcDVAM1?si=7ce4852af1994fd1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273215e170d8ecfbf69b42fbbc1" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>PRICE TAGS</strong><br/>
                (prod. TF)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1MzvqVAnvVH1uq6ABu3YOD?si=b33d2a14b76f4d05" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27331aa40e4a26af9a6a087fbba" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>** ASSUMPTIONS **</strong><br/>
                (prod. Sorrow Bringer)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5T4qMcDARYNQRvKmAmUjRV?si=710e1ff6cf7d44f9" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273d8db225c56bc4463a1da4e71" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>letdown</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/28zbVxCo8i1u2qhCGVgxT1?si=7044d8d0a418430d" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273f0df6279b87e24dff9ba6ab1" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>50PACK</strong><br/>
                (feat. Yung Scuff)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3PLO9EIeEjTX6F2iI2F6EH?si=5247c064d3f540b6" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273647ee7b32c9d2e7f160ff352" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Wanting More</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3j3x6f7OFqvH4nslihqIQZ?si=20bfc6498d7b4eae" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-UjaOyHYlonQ52zpw-8pjinw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>time runs away</strong><br/>
                (prod. brntbrdgs)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/7Ghnc10i1nGiwidmowXBDE?si=a096913af7cd4b83" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02fcb672faa4441b879395498b" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>still hurts.</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/2OPQCy6PmR2pu5HKmRyf3U?si=115021a785234d3c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d00001e02b493b517ef3d17ff2a4dfbf9" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>AMILLIONPIECES</strong><br/>
                (feat. THROB)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5QXREjsvCAs8PpLOLDORXS?si=8fc9f952b4e7426c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-VAAxAH9JF0YS9iyS-OqEQhA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>666</strong><br/>
                (prod. KAOS)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3M4c1hgqC7Tz3uwjrQZXAt?si=73acc4ff493e48e6" target="_blank" rel="noopener noreferrer">    
              <img src="https://is3-ssl.mzstatic.com/image/thumb/Music114/v4/be/3b/27/be3b2789-0d47-bb66-deec-6fdd0bf85b65/artwork.jpg/1000x1000bb.webp" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Hip Thick</strong><br/>
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1tovgI7bubRlBBlb92sgPf?si=9384aab71ebb483f" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-YzdfAb4rrm9Q0kSI-FSF63A-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>yeah yeah</strong><br/>
                (prod. Howler)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/3ckUl7ir1nuRMrfsXh9aVs?si=f241a89d23e84560" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zbmvdYe3K5ft25BM-INUGsQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Luvr Boy</strong><br/>
                (prod. Yung Prenup)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/lillugosi/gtfoomyf-prod-5head" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-YNDzn7Sa7RtZ25O9-ao4zNw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>GTTHFCKTFMYC</strong><br/>
                (prod. 5head)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/4oqtxg9g2wKE7B4R8bKzDm?si=b55d00239eba49f5" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-vLYZfprKC0nNcSAA-hces8g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Failure</strong><br/>
                (prod. Caspr)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/0PDjtLv3QgzJ3EOlAD6Hwu?si=1583aa2450934010" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-UbIzjzpzLTAKlwtR-4oznTg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Fucked Up</strong><br/>
                (prod. Yago)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/5sUphAFyEzWFGNJjZOPGJq?si=1d4454e03b504e9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Ryebr5ObPachfo9K-xu67IA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Fairytale</strong><br/>
                (prod. 10kreditkarten)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/20TuMuagg24n48z9lBGal1?si=9083c5b8b383450a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-aWB7dvwVPPIZvmbi-o70Wdg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Vampire</strong><br/>
                (prod. Off Popo)
              </p>
            </a>
          </div>   

        </div>
      </>
    );
  };
  export default LugosiAllReleasesStatic;